<!-- Content Wrapper Start -->
<div class="fm-content-wrapper fm-schedule-page">
  <div class="container-fluid">
    <!-- ══════════════════════════════════════════════════════════════════
          Page Header — Title + Create button
          ══════════════════════════════════════════════════════════════════ -->
    <div class="row">
      <div class="col-12">
        <div class="row align-items-center">
          <div class="col-sm">
            <div class="fm-page-title">
              <h2 class="fm-head-24 fm-title mb-2">Scheduled Prompts</h2>
              <p class="mb-0">Automate memory collection with gentle reminders</p>
            </div>
          </div>
          <div class="col-auto">
            <a routerLink="/app/scheduleprompt/create" class="fm-common-btn">
              <img src="images/icons/fm-plus-large.svg" class="fm-svg" alt="Plus Icon" />
              Create New Prompt
            </a>
          </div>
        </div>
      </div>

      <!-- ══════════════════════════════════════════════════════════════════
            Ownership Tabs — Created / Invited (replaces the old "Type" dropdown)
            ══════════════════════════════════════════════════════════════════ -->
      @if (typeOptions().length) {
        <div class="col-12 mt-3 mb-3">
          <div class="fm-filter-btn-grp fm-ownership-tab-grp" role="tablist">
            @for (opt of typeOptions(); track opt.id) {
              <button
                type="button"
                class="fm-filter-cl-btn fm-ownership-tab-btn"
                [class.fm-fb-active]="activeType() === opt.name"
                role="tab"
                [attr.aria-selected]="activeType() === opt.name"
                (click)="onTypeChange(opt.name)"
              >{{ getTabLabel(opt.name) }}</button>
            }
          </div>
        </div>
      }

      <!-- ══════════════════════════════════════════════════════════════════
            Summary Stats Cards — driven by summaryStats signal
            ══════════════════════════════════════════════════════════════════ -->
      <div class="col-12 mt-4 mt-sm-0">
        @if (activeStatus() !== 5) {
          <div class="fm-cards-group">
            <div class="row g-3">
              <div class="col-sm-3 col-xxl-3">
                <div class="fm-white-column fm-card-icon fm-metric-card">
                  <div class="fm-card-content">
                    <h3 class="fm-head-32 fm-title">{{ summaryStats().totalSchedules }}</h3>
                    <p class="fm-large mb-0">{{ activeStatus() === 3 ? 'Completed Schedules' : 'Active Schedules' }}</p>
                  </div>
                  <div class="fm-metric-icon">
                    <img src="images/icons/fm-send.svg" class="fm-svg" alt="Active Schedules" />
                  </div>
                </div>
              </div>

              <div class="col-sm-3 col-xxl-3">
                <div class="fm-white-column fm-card-icon fm-metric-card">
                  <div class="fm-card-content">
                    <h3 class="fm-head-32 fm-title">{{ summaryStats().overallResponseRate }}%</h3>
                    <p class="fm-large mb-0">Response Rate</p>
                  </div>
                  <div class="fm-metric-icon">
                    <img src="images/icons/fm-check-lg.svg" class="fm-svg" alt="Response Rate" />
                  </div>
                </div>
              </div>

              <div class="col-sm-3 col-xxl-3">
                <div class="fm-white-column fm-card-icon fm-metric-card">
                  <div class="fm-card-content">
                    <h3 class="fm-head-32 fm-title">{{ summaryStats().totalStoriesCreated }}</h3>
                    <p class="fm-large mb-0">Stories Created</p>
                  </div>
                  <div class="fm-metric-icon">
                    <img src="images/icons/fm-book-lg.svg" class="fm-svg" alt="Stories Created" />
                  </div>
                </div>
              </div>

              <div class="col-sm-3 col-xxl-3">
                <div class="fm-white-column fm-card-icon fm-metric-card">
                  <div class="fm-card-content">
                    <h3 class="fm-head-32 fm-title">{{ summaryStats().activeRecipients }}</h3>
                    <p class="fm-large mb-0">Active Recipients</p>
                  </div>
                  <div class="fm-metric-icon">
                    <img src="images/icons/fm-pending.svg" class="fm-svg" alt="Active Recipients" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════
          Filter Row — Search | Category | Status | Type
          ══════════════════════════════════════════════════════════════════ -->
    <div class="row g-3 align-items-center">
      <div class="col-xl col-xxl-4">
        <h3 class="fm-head-24 fm-title-dark">All Scheduled Prompts</h3>
      </div>
      <div class="col-xl-auto col-xxl-8">
        <div class="fm-prompt-filter">
          <div class="row g-3">
            <!-- Search -->
            <div class="col-md-4 col-lg-5">
              <div class="fm-searchbar">
                <form (ngSubmit)="onSearch()">
                  <div class="form-group">
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Search prompts by title or keyword..."
                      aria-label="Search prompts"
                      [(ngModel)]="customSearch"
                      name="promptSearch"
                    />
                  </div>
                  @if (submittedSearch()) {
                    <button
                      type="button"
                      class="fm-search-btn"
                      (click)="clearSearch()"
                      aria-label="Clear search"
                    >
                      &#x2715;
                    </button>
                  } @else {
                    <button class="fm-search-btn" type="submit" aria-label="Search">
                      <img src="images/icons/fm-search-icon.svg" class="fm-svg" alt="Search Icon" />
                    </button>
                  }
                </form>
              </div>
            </div>

            <!-- Dropdowns -->
            <div class="col-md-7 col-lg-6">
              <div class="row g-3">
                <!-- Category -->
                <div class="col-6 col-sm-6">
                  <select
                    class="form-select fm-form-select"
                    aria-label="Filter by Category"
                    [value]="activeCategoryId() ?? ''"
                    (change)="onCategoryChange($any($event.target).value)"
                  >
                    <option value="">All Category</option>
                    @for (cat of categories(); track cat.categoryId) {
                      <option [value]="cat.categoryId">{{ cat.categoryName }}</option>
                    }
                  </select>
                </div>

                <!-- Status -->
                <div class="col-6 col-sm-6">
                  <select
                    class="form-select fm-form-select"
                    aria-label="Filter by Status"
                    [value]="activeStatus() ?? ''"
                    (change)="onStatusChange($any($event.target).value)"
                  >
                    <option value="">All Status</option>
                    @for (opt of statusOptions(); track opt.id) {
                      <option [value]="opt.id">{{ opt.name }}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════
          Prompts Area — hidden while initializing (global loader shown);
          mutually exclusive states once data is ready:
            1. Error    → retry message
            2. Empty (no prompts in system)  → "create first prompt"
            3. Empty (filters active)        → "no results found"
            4. Success  → list of prompt cards + infinite scroll
          ══════════════════════════════════════════════════════════════════ -->

    @if (!isInitializing()) {
      <!-- ── 1. API / network error ── -->
      @if (hasError()) {
        <div class="row g-3 mt-2">
          <div class="col-12">
            <div class="fm-white-column text-center">
              <h4 class="fm-head-24 fm-head-sty2">Something went wrong</h4>
              <p class="mb-3">
                We couldn't load your prompts. Please check your connection and try again.
              </p>
            </div>
          </div>
        </div>
      }

      <!-- ── 2. Empty — nothing in the system at all ── -->
      @else if (prompts().length === 0 && !hasPromptsInSystem()) {
        <div class="row g-3 mt-2">
          <div class="col-12">
            <div class="fm-white-column text-center">
              <h4 class="fm-head-24 fm-head-sty2">No scheduled prompts yet</h4>

              <p class="mb-3">
                Start automating your memory collection — create your first scheduled prompt now.
              </p>

              <a routerLink="/app/scheduleprompt/create" class="fm-common-btn">
                <img src="images/icons/fm-plus-large.svg" class="fm-svg" alt="Plus Icon" />
                Create New Prompt
              </a>
            </div>
          </div>
        </div>
      }

      <!-- ── 3. Empty — filters/search returned nothing ── -->
      @else if (prompts().length === 0 && hasPromptsInSystem()) {
        <div class="row g-3 mt-2">
          <div class="col-12">
            <div class="fm-white-column text-center">
              <h4 class="fm-head-24 fm-head-sty2">No prompts found</h4>
              <p class="mb-0">Try a different search term or filter to see available prompts.</p>
            </div>
          </div>
        </div>
      }

      <!-- ── 4. Success — prompt cards ── -->
      @else {
        <div class="row g-3 mt-2">
          <div class="col-12">
            <div class="fm-cards-list">
              @for (prompt of prompts(); track prompt.schedulePromptId; let i = $index) {
                <div class="fm-prompt-card">
                  <div class="fm-card-header">
                    <div class="fm-card-number">{{ getPromptIndex(i) }}</div>

                    <div class="fm-card-body">
                      <!-- Top: title + badges + actions -->
                      <div class="fm-card-top">
                        <div>
                          @if (prompt.promptOwnershipType.toLowerCase() === 'invited') {
                            <a
                              class="fm-card-title"
                              [routerLink]="[
                                '/app/scheduleprompt/invitee-view',
                                prompt.schedulePromptId,
                              ]"
                              >{{ prompt.promptTitle }}</a
                            >
                          } @else {
                            <a
                              class="fm-card-title"
                              [routerLink]="[
                                '/app/scheduleprompt/overview',
                                prompt.schedulePromptId,
                              ]"
                              >{{ prompt.promptTitle }}</a
                            >
                          }
                          <div class="fm-card-tags">
                            <span
                              class="fm-badge"
                              [ngClass]="getStatusBadgeClass(prompt.scheduleStatus)"
                            >
                              {{ prompt.scheduleStatusName }}
                            </span>
                            @if (prompt.categoryName) {
                              <p class="mb-0">
                                <img
                                  class="fm-svg fm-category-icon"
                                  [src]="
                                    prompt.categoryIconUrl || 'images/icons/fm-childhood-grey.svg'
                                  "
                                  alt="Category"
                                />
                                {{ prompt.categoryName }}
                              </p>
                            }
                            @if (prompt.promptOwnershipType) {
                              <span class="fm-badge fm-badge-secondary">
                                {{
                                  prompt.promptOwnershipType === 'CreatedByMe'
                                    ? 'Created by Me'
                                    : prompt.promptOwnershipType
                                }}
                              </span>
                            }
                          </div>
                        </div>
                        <!-- <div class="fm-card-actions">
                          <button class="fm-btn-icon" type="button" title="Edit" aria-label="Edit">
                            <img
                              src="images/icons/fm-edit-pen.svg"
                              class="fm-svg"
                              alt="Edit Icon"
                            />
                          </button>
                          <button
                            class="fm-btn-icon"
                            type="button"
                            title="Delete"
                            aria-label="Delete"
                            (click)="openDeleteConfirm(prompt.schedulePromptId)"
                          >
                            <img
                              src="images/icons/fm-delete-bl.svg"
                              class="fm-svg"
                              alt="Delete Icon"
                            />
                          </button>
                        </div> -->
                      </div>

                      <!-- Info grid -->
                      <div
                        class="fm-info-grid"
                        [class.fm-info-grid-3col]="
                          prompt.scheduleStatus === 3 || prompt.scheduleStatus === 5
                        "
                      >
                        <div class="fm-info-item">
                          <p class="fm-label">How Often</p>
                          <h5 class="fm-card-title">{{ prompt.frequencyTypeName || '—' }}</h5>
                        </div>
                        @if (prompt.scheduleStatus !== 3 && prompt.scheduleStatus !== 5) {
                          <div class="fm-info-item">
                            <p class="fm-label">Next Reminder</p>
                            <h5 class="fm-card-title">{{ formatNextDelivery(prompt.nextDeliveryDate) }}</h5>
                          </div>
                        }
                        <div class="fm-info-item">
                          <p class="fm-label">Delivery Method</p>
                          <h5 class="fm-card-title">{{ prompt.deliveryMethodTypeName || '—' }}</h5>
                        </div>
                        <div class="fm-info-item">
                          <div class="fm-response-header">
                            <p class="fm-label">Response Rate</p>
                            <h5 class="fm-card-title">{{ prompt.responseRate }}%</h5>
                          </div>
                          <div class="fm-progress">
                            <span [style.width.%]="prompt.responseRate"></span>
                          </div>
                        </div>
                      </div>

                      <!-- Footer: sent-to members -->
                      @if (
                        prompt.sentToMembers?.length &&
                        prompt.promptOwnershipType.toLowerCase() !== 'invited' &&
                        (prompt.scheduleStatus === 1 ||
                          prompt.scheduleStatus === 7 ||
                          prompt.scheduleStatus === 3 ||
                          prompt.scheduleStatus === 2)
                      ) {
                        <div class="fm-card-footer">
                          <div class="fm-footer-row">
                            <div class="fm-footer-left">
                              <p class="fm-label mb-0">Send to</p>
                              <div class="fm-pills">
                                @for (member of prompt.sentToMembers; track member.memberId) {
                                  <div class="fm-pill-wrapper">
                                    <a
                                      class="fm-pill"
                                      [routerLink]="[
                                        '/app/scheduleprompt/creator-view',
                                        prompt.schedulePromptId,
                                        member.memberId,
                                      ]"
                                    >
                                      <span class="fm-dot fm-dot-initials"></span>
                                      {{ member.displayName }}
                                    </a>
                                    <button
                                      class="fm-pill-remove"
                                      type="button"
                                      title="Remove member"
                                      (click)="
                                        openRemoveMemberConfirm(
                                          prompt.schedulePromptId,
                                          member.memberId,
                                          member.displayName
                                        )
                                      "
                                    >
                                      &#x2715;
                                    </button>
                                  </div>
                                }

                                <!-- Add member button — only if no prompts delivered yet -->
                                @if (prompt.canAddMembers) {
                                  <button
                                    class="fm-pill-add"
                                    type="button"
                                    title="Add member"
                                    (click)="
                                      openAddMember(prompt.schedulePromptId, getMemberIds(prompt))
                                    "
                                  >
                                    <i class="bi bi-plus" aria-hidden="true"></i>
                                    Add Member
                                  </button>
                                }
                              </div>
                            </div>

                            @if (prompt.scheduleStatus === 1 || prompt.scheduleStatus === 7) {
                              <button
                                class="fm-stop-btn"
                                type="button"
                                title="Stop Prompt"
                                (click)="openStopConfirm(prompt.schedulePromptId)"
                              >
                                <i class="bi bi-stop-circle" aria-hidden="true"></i>
                                Stop Prompt
                              </button>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>

        <!-- ── Infinite-scroll: load-more spinner ── -->
        @if (isLoadingMore()) {
          <div class="fm-load-more-spinner text-center py-4">
            <div
              class="spinner-border"
              role="status"
              style="width: 1.75rem; height: 1.75rem; border-width: 3px"
            >
              <span class="visually-hidden">Loading more prompts…</span>
            </div>
          </div>
        }

        <!-- Sentinel — IntersectionObserver watches this to trigger the next page -->
        @if (hasMorePrompts()) {
          <div id="promptsScrollSentinel" class="fm-scroll-sentinel"></div>
        }
      }
    }
    <!-- end @if (!isInitializing()) -->
  </div>
  <!-- ══════════════════════════════════════════════════════════════════
      Delete Confirmation Modal
      ══════════════════════════════════════════════════════════════════ -->
  @if (stoppingPromptId()) {
    <div class="fm-modal-overlay" (click)="cancelStop()">
      <div class="fm-modal" (click)="$event.stopPropagation()">
        <div class="fm-modal-icon fm-modal-icon-stop">
          <img src="images/icons/fm-delete.svg" class="fm-svg" alt="Stop" />
        </div>

        <h4 class="fm-head-24 fm-title-dark">Stop Scheduled Prompt?</h4>
        <p class="fm-modal-desc">
          All pending and upcoming question deliveries will be cancelled — invitees can no longer
          record or submit new responses for this prompt.
        </p>
        <p class="fm-modal-note">
          Responses already submitted by invitees will remain as standalone stories in their memory
          libraries and will not be affected.
        </p>

        @if (stopError()) {
          <div class="fm-alert fm-alert-danger">{{ stopError() }}</div>
        }

        <div class="fm-modal-actions">
          <button
            type="button"
            class="fm-outline-btn"
            (click)="cancelStop()"
            [disabled]="isStopping()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="fm-stop-confirm-btn"
            (click)="confirmStop()"
            [disabled]="isStopping()"
          >
            @if (isStopping()) {
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              Stopping...
            } @else {
              Stop Prompt
            }
          </button>
        </div>
      </div>
    </div>
  }

  @if (addMemberPrompt()) {
    <div class="fm-modal-overlay" (click)="cancelAddMember()">
      <div class="fm-modal fm-modal-lg" (click)="$event.stopPropagation()">
        <div class="fm-modal-icon fm-modal-icon-add">
          <i class="bi bi-person-plus" aria-hidden="true"></i>
        </div>

        <h4 class="fm-head-24 fm-title-dark">Add Members</h4>
        <p class="fm-modal-desc">
          Select family members to add to this scheduled prompt. They will receive the next
          scheduled question via the same delivery method.
        </p>

        @if (isLoadingFamilyMembers()) {
          <div class="fm-member-loading">
            <div class="spinner-border spinner-border-sm" role="status"></div>
            <span>Loading members...</span>
          </div>
        } @else if (familyMembers().length === 0) {
          <p class="fm-modal-note">No family members available to add.</p>
        } @else if (allMembersAlreadyAdded()) {
          <div class="fm-modal-note fm-all-added-msg">
            <i
              class="bi bi-check-circle-fill"
              style="color: var(--fm-success, #28a745); margin-right: 6px"
            ></i>
            All your family members are already part of this prompt.
          </div>
        } @else {
          <div class="fm-member-list">
            @for (member of familyMembers(); track member.familyMemberId) {
              @if (!addMemberPrompt()!.existingMemberIds.includes(member.familyMemberId)) {
                <div
                  class="fm-member-item"
                  [class.fm-member-selected]="selectedMemberIds().includes(member.familyMemberId)"
                  (click)="toggleMemberSelection(member.familyMemberId)"
                >
                  <div class="fm-member-avatar">
                    @if (member.image) {
                      <img [src]="member.image" [alt]="member.fullName" />
                    } @else {
                      <span>{{ member.fullName[0] }}</span>
                    }
                  </div>
                  <div class="fm-member-info">
                    <p class="fm-member-name">{{ member.fullName }}</p>
                    <p class="fm-member-rel">{{ member.relationship }}</p>
                  </div>
                  <div class="fm-member-check">
                    @if (selectedMemberIds().includes(member.familyMemberId)) {
                      <i class="bi bi-check-circle-fill" aria-hidden="true"></i>
                    } @else {
                      <i class="bi bi-circle" aria-hidden="true"></i>
                    }
                  </div>
                </div>
              }
            }
          </div>
        }

        @if (addMemberError()) {
          <div class="fm-alert fm-alert-danger">{{ addMemberError() }}</div>
        }

        <div class="fm-modal-actions">
          <button
            type="button"
            class="fm-outline-btn"
            (click)="cancelAddMember()"
            [disabled]="isAddingMember()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="fm-common-btn"
            (click)="confirmAddMember()"
            [disabled]="isAddingMember() || selectedMemberIds().length === 0"
          >
            @if (isAddingMember()) {
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              Adding...
            } @else {
              Add Selected ({{ selectedMemberIds().length }})
            }
          </button>
        </div>
      </div>
    </div>
  }

  @if (removingMember()) {
    <div class="fm-modal-overlay" (click)="cancelRemoveMember()">
      <div class="fm-modal" (click)="$event.stopPropagation()">
        <div class="fm-modal-icon">
          <img src="images/icons/fm-delete-bl.svg" class="fm-svg" alt="Remove" />
        </div>

        <h4 class="fm-head-24 fm-title-dark">Remove Member?</h4>
        <p class="fm-modal-desc">
          <strong>{{ removingMember()?.name }}</strong> will be removed from this scheduled prompt.
          All future deliveries to this member will be stopped immediately.
        </p>
        @if (removeMemberError()) {
          <div class="fm-alert fm-alert-danger">{{ removeMemberError() }}</div>
        }

        <div class="fm-modal-actions">
          <button
            type="button"
            class="fm-outline-btn"
            (click)="cancelRemoveMember()"
            [disabled]="isRemovingMember()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="fm-stop-confirm-btn"
            (click)="confirmRemoveMember()"
            [disabled]="isRemovingMember()"
          >
            @if (isRemovingMember()) {
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              Removing...
            } @else {
              Remove Member
            }
          </button>
        </div>
      </div>
    </div>
  }
</div>
<!-- Content Wrapper End -->
